export default "__VITE_ASSET__De071BHU__"